import styled from 'styled-components';
import { BasedCardsContainer } from '../../ui/CardsLayout/styled';

export const FormStyled = styled.form`
  margin-bottom: 40px;
  border-radius: 21px;

  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    background-color: ${({ theme }) => theme.colors.background.primary};
    padding: 15px;
  }
`;

export const PashaCardsContainer = styled(BasedCardsContainer)`
  min-height: 638px;

  > div {
    height: min-content;

    &:not(:nth-last-child(-n + 5)) {
      margin-bottom: 10px;
    }

    @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
      &:not(:nth-last-child(-n + 5)) {
        margin-bottom: 65px;
      }
    }

    .price-container {
      gap: 5px;
    }
  }
`;
